<template>
  <div>
    <oct-globalnav
      :user="user"
      @signout="onSignout"
    />

    <oct-favorite-form
      class="oct-favorite__form"
      :user="user"
      :token="this.token"
      @update="onUpdate"
      v-if="initialized"
    />

    <oct-dot-progress
      v-if="!initialized"
    />

    <oct-globalfooter
      :user="user"
      @signout="onSignout"
      @quit="onQuit"
    />

    <oct-svg />
  </div>
</template>

<script>
import OctAuth from '@/components/auth/OctAuth.js'
import OctPrototypeView from '@/views/OctPrototypeView.js'
import OctFavoriteForm from '@/components/favorite-form/OctFavoriteForm.vue';
import OctSvg from '@/components/svg/OctSvg.vue'
import '@/assets/app.scss'

export default {
  mixins: [OctAuth, OctPrototypeView],
  name: 'OctAccount',
  data () {
    return {}
  },
  components: {
    OctFavoriteForm,
    OctSvg
  },
  methods: {
    /** Update handler */
    async onUpdate () {
      // Refresh user data
      this.user = await this.whoami()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../components/theme/variables";
@import "../components/grid/variables";
@import "../components/typography/variables";
@import "../components/typography/mixins";

.oct-favorite__form {
  min-height: oct-rem(640-64-48);

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  min-height: oct-rem(720-96-72);
}
}
</style>